import { Sparkles, FileEdit, ShieldCheck, Gavel, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const STEPS = [
  {
    n: "01",
    icon: Sparkles,
    title: "Configura tu universidad en 60 segundos",
    body:
      "Te preguntamos país, universidad, carrera y tu título tentativo. Cargamos automáticamente la plantilla con APA 7, Vancouver o Harvard según tu institución.",
  },
  {
    n: "02",
    icon: FileEdit,
    title: "Escribe con un copiloto que entiende metodología",
    body:
      "Editor pantalla partida: tu tesis a la izquierda, Claude Sonnet 4.6 a la derecha. Te ayuda con redacción, citas APA inline y RAG con artículos reales de OpenAlex.",
  },
  {
    n: "03",
    icon: ShieldCheck,
    title: "Valida coherencia y detecta riesgo de IA",
    body:
      "GPT-4o evalúa la coherencia metodológica con score 1-100. Métrica antiplagio detecta párrafos robóticos y los reescribe en voz activa académica humana.",
  },
  {
    n: "04",
    icon: Gavel,
    title: "Sella tu autoría y prepara tu defensa",
    body:
      "Cada guardado se sella en un ledger criptográfico SHA-256. El Simulador de Jurado te bombardea con 3 preguntas brutales y te entrega un reporte de fortalezas.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="como-funciona"
      data-testid="section-how-it-works"
      className="relative scroll-mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-24 lg:py-32">
        <div className="max-w-2xl">
          <p className="text-[11px] tracking-[0.28em] uppercase text-copper font-medium">
            Cómo funciona
          </p>
          <h2 className="mt-3 font-serif text-4xl sm:text-5xl text-ink leading-[1.05] text-balance">
            De la página en blanco a la <span className="italic text-forest">defensa final</span>, en 4 pasos.
          </h2>
          <p className="mt-4 text-[15px] text-ink-soft max-w-xl leading-relaxed">
            No es magia. Es un flujo claro donde tú escribes, decides y firmas.
            Nosotros nos ocupamos del rigor metodológico, el formato, las
            citas y la prueba de autoría.
          </p>
        </div>

        <ol className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-5">
          {STEPS.map((s) => (
            <li
              key={s.n}
              data-testid={`how-step-${s.n}`}
              className="relative rounded-2xl border border-rule bg-white p-6 lg:p-7"
            >
              <div className="flex items-start gap-4">
                <span className="font-serif text-3xl text-copper/90 leading-none">
                  {s.n}
                </span>
                <div className="flex-1">
                  <div className="inline-flex items-center gap-1.5 text-forest mb-2">
                    <s.icon size={14} />
                  </div>
                  <h3 className="font-serif text-[1.35rem] text-ink leading-snug">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-[13.5px] text-ink-soft leading-relaxed">
                    {s.body}
                  </p>
                </div>
              </div>
            </li>
          ))}
        </ol>

        <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <Link
            to="/signup"
            data-testid="how-cta"
            className="group inline-flex items-center gap-2 px-6 py-3.5 rounded-full text-[14px] font-medium text-paper bg-forest hover:bg-forest-dark shadow-[0_18px_36px_-12px_rgba(39,59,44,0.45)]"
          >
            Empezar gratis ahora
            <ArrowRight size={14} className="transition-transform group-hover:translate-x-0.5" />
          </Link>
          <p className="text-[12.5px] text-ink-soft">
            Sin tarjeta. Configura tu plantilla en 60 segundos.
          </p>
        </div>
      </div>
    </section>
  );
}
